import React from 'react';
import '../../../css/Admin.css';
import TituloPagina from '../../../js/Components/PageTitle';

const Agenda: React.FC = () => {
      return (
        <div>
        <TituloPagina title="ADMIN - Agenda | DentalPuente" />

<div className="pbot352">
      
Agenda Aqui
    </div>
    </div>
    );
}

export default Agenda;
